import { type JSX } from "react";
import Head from "next/head";
import { ComponentProps } from "lib/component-props";

export type CustomMetadataProps = ComponentProps;

const parseKeyValuePairs = (input?: string): Record<string, string> => {
  const result: Record<string, string> = {};
  if (!input) return result;

  for (const pair of input.split("&")) {
    const [key, value] = pair.split("=");
    if (key && value) result[key] = value;
  }
  return result;
};

interface RouteWithCustomFields {
  fields?: {
    Attributes?: { value?: string };
  };
}

export const Default = (props: CustomMetadataProps): JSX.Element => {
  console.log("---->[CustomMetadata] Component");

  const { page } = props;
  const isPageEditing = page.mode.isEditing;
  const isPartialDesign =
    page.layout.sitecore.route?.templateName === "Partial Design";

  if (isPageEditing && isPartialDesign) {
    return (
      <div className="is-metadata-hint">
        <strong>Metadata:</strong> Custom Meta Tags
      </div>
    );
  }

  const route = page.layout.sitecore.route as RouteWithCustomFields | null;
  const kvp = parseKeyValuePairs(route?.fields?.Attributes?.value);

  return (
    <Head>
      {Object.entries(kvp).map(([key, value]) => (
        <meta key={key} name={key} content={value} />
      ))}
    </Head>
  );
};
